export default {"src":"/_next/static/media/chicken-outline-icon.915b5044.svg","height":30,"width":60,"blurWidth":0,"blurHeight":0};